import { TrainingInterface, TrainingState } from "module/training/types";

export const isTrainingStateScheduledOrLower = (
  training: TrainingInterface
): boolean =>
  [TrainingState.initScheduled, TrainingState.scheduled].includes(
    training.state
  );
